<template>
  <div>
    <slot v-bind:options="options"></slot>
  </div>
</template>

<script>
// import apiService

export default {
  data() {
    return {
      options: []
    };
  },
  props: {
    // endpoint: {
    //     type: String,
    //     required: true
    // },
    // filters: Object,
  },
  mounted() {
    setTimeout(() => {
      this.options = [
        {
          key: 1,
          label: "Value"
        },
        {
          key: 2,
          label: "Value 2"
        },
        {
          key: 3,
          label: "Value 3"
        },
        {
          key: 4,
          label: "Value 4"
        },
        {
          key: 5,
          label: "Value 5"
        }
      ];
    }, 5000);
  }
};
</script>
